import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { EmptyState } from '@lumapps/lumx-states/components/EmptyState';
import { mdiBell, mdiBellCheck } from '@lumapps/lumx/icons';
import { useSelector } from '@lumapps/redux/react';
import { useTranslate } from '@lumapps/translations';

import { isNotificationsBetaEnabled } from '../../ducks/selectors';
import { NOTIFICATIONS_CENTER } from '../../keys';

const CLASSNAME = 'notification-center-empty-list';

/**
 * Empty state when no notifications
 */
const NotificationEmptyList: React.FC = () => {
    const { translateKey } = useTranslate();
    const { block } = useClassnames(CLASSNAME);
    const isNotificationsEnabled = useSelector(isNotificationsBetaEnabled);

    return isNotificationsEnabled ? (
        <EmptyState
            iconProps={{
                icon: mdiBellCheck,
            }}
            title={translateKey(NOTIFICATIONS_CENTER.UP_TO_DATE)}
            message={translateKey(NOTIFICATIONS_CENTER.EMPTY_NOTIFICATIONS_MESSAGE)}
            titleProps={{ as: 'h2' }}
            wrapperProps={{ className: block() }}
        />
    ) : (
        <EmptyState
            iconProps={{
                icon: mdiBell,
            }}
            title={translateKey(NOTIFICATIONS_CENTER.NO_NEW_NOTIFICATION)}
            titleProps={{ as: 'h2' }}
            wrapperProps={{ className: block() }}
        />
    );
};

export { NotificationEmptyList };
